import clsx from 'clsx';
import { Icon } from '../../../layout/Icon.jsx';
import { printBarcode } from '../../../shared/printBarcode.js';

export function generateEAN13() {
  const base = '620';
  const ts = (Date.now() % 10000) * 7;
  const body = `${base}${String(ts).padStart(9, '0')}`.slice(0, 12);
  let sum = 0;
  for (let i = 0; i < 12; i += 1) {
    const n = Number(body[i]);
    sum += i % 2 === 0 ? n : n * 3;
  }
  const check = (10 - (sum % 10)) % 10;
  return `${body}${check}`;
}

export function BarcodeField({ value, onChange, error, productName, sku, price }) {
  const canPrint = !!(value && String(value).trim());
  return (
    <div>
      <label className="block text-xs font-semibold text-ink-2 mb-1">الباركود</label>
      <div className="flex gap-1.5">
        <input
          className={clsx('input flex-1', error && 'border-red')}
          value={value || ''}
          placeholder="ضع المؤشر وامسح أو أدخل يدوياً"
          dir="ltr"
          style={{ fontFamily: 'monospace', textAlign: 'right' }}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          className="btn"
          title="توليد باركود EAN-13"
          onClick={() => onChange(generateEAN13())}
        >
          <Icon name="scan" size={14} /> توليد
        </button>
        <button
          type="button"
          className="btn"
          disabled={!canPrint}
          title={canPrint ? 'طباعة الباركود' : 'أدخل أو ولّد باركود أولاً'}
          onClick={() =>
            printBarcode({
              value: String(value).trim(),
              label: productName,
              sku,
              price
            })
          }
        >
          <Icon name="print" size={14} /> طباعة
        </button>
      </div>
      {error ? <div className="text-red text-[11.5px] mt-1 font-semibold">{error}</div> : null}
    </div>
  );
}
